/* ================= i18n ================= */
const I18N = {
  en: {
    hero_eyebrow: "upcoming · retro-futuristic clothing",
    hero_dropline: "drop 01 · 2026 · luxembourg",
    scroll: "scroll",
    dep_eyebrow: "arrivals",
    dep_title: "The first collection is boarding.",
    dep_sub: "Drop 01 is on its way. No date yet — some things aren't meant to be rushed.",
    board_gate: "gate", board_flight: "flight", board_col: "collection", board_status: "status",
    leak_stamp: "leaked — internal",
    leak_eyebrow: "first look",
    leak_title: "Drop 01 — <span class=\"nowrap\">seen before it exists.</span>",
    leak_cap: "drop 01",
    world_title: "Late nights, empty terminals, a future that never quite happened.",
    world_sub: "– where aekon lives",
    cap_terminal: "terminal · 03:00",
    cap_car: "everything visible",
    cap_pool: "the pool nobody swims in",
    cap_monorail: "transit · somewhere in 1999",
    cap_dash: "night drive, green light",
    cap_room: "sunday, 4pm",
    cap_money: "Big money never comes clean",
    cap_horse: "a gift",
    leak_next: "next pieces",
    leak_lose: "lose",
    cap_jet: "i'm out",
    quote: "aekon doesn't sell sportswear. it doesn't sell streetwear either. it sells performative lifestyle — clothing that works from the gate to the coast.",
    quote_attr: "aekon · drop 01",
    footer_contact: "contact", footer_founders: "founders — Finn SCHMIT & Arnel BURKIC",
    app_hint: "aekon, as an app", app_title: "add aekon to your home screen", app_intro: "here's how:",
    app_ios: ["Tap the share icon at the bottom of Safari","Scroll down and tap \"Add to Home Screen\"","Tap \"Add\" — aekon lands next to your apps"],
    app_android: ["Tap the three dots (⋮) in your browser","Tap \"Add to Home screen\" or \"Install app\"","Confirm — aekon lands on your home screen"],
    app_desktop: ["Click the install icon at the right end of the address bar","Confirm \"Install\" — aekon opens in its own window"],
    cta_btn: "add me to the manifest",
    cta_note: "one address, one message — when drop 01 boards. nothing in between.",
    form_ph: "your email address", form_send: "board", form_ok: "you're on the manifest — we'll signal you when drop 01 boards.", form_err: "couldn't send automatically — please use the address below.",
    fb_title: "Mail app didn't open?", fb_copy: "copy address", fb_copied: "copied ✓", fb_close: "close",
    mail_subject: "Interest — aekon drop 01 (jacket & shorts)",
    mail_body: "Hi aekon team,\n\nI'm interested in the drop 01 set (zip-up jacket + shorts).\nSize: \nCountry: \n\n"
  },
  de: {
    hero_eyebrow: "upcoming · retro-futuristische kleidung",
    hero_dropline: "drop 01 · 2026 · luxemburg",
    scroll: "scrollen",
    dep_eyebrow: "ankünfte",
    dep_title: "Die erste Kollektion boardet.",
    dep_sub: "Drop 01 ist unterwegs. Noch kein Datum — manche Dinge lassen sich nicht drängen.",
    board_gate: "gate", board_flight: "flug", board_col: "kollektion", board_status: "status",
    leak_stamp: "geleakt — intern",
    leak_eyebrow: "erster blick",
    leak_title: "Drop 01 — <span class=\"nowrap\">gesehen, bevor es existiert.</span>",
    leak_cap: "drop 01",
    world_title: "Späte Nächte, leere Terminals, eine Zukunft, die nie ganz kam.",
    world_sub: "– wo aekon lebt",
    cap_terminal: "terminal · 03:00",
    cap_car: "alles sichtbar",
    cap_pool: "der pool, in dem niemand schwimmt",
    cap_monorail: "transit · irgendwo in 1999",
    cap_dash: "nachtfahrt, grünes licht",
    cap_room: "sunday, 4pm",
    cap_money: "Big money never comes clean",
    cap_horse: "a gift",
    leak_next: "next pieces",
    leak_lose: "lose",
    cap_jet: "i'm out",
    quote: "aekon verkauft keine sportkleidung. auch keine streetwear. aekon verkauft performative lifestyle — kleidung, die vom gate bis zur küste funktioniert.",
    quote_attr: "aekon · drop 01",
    footer_contact: "kontakt", footer_founders: "gründer — Finn SCHMIT & Arnel BURKIC",
    app_hint: "aekon, als app", app_title: "aekon zum home-bildschirm", app_intro: "so geht's:",
    app_ios: ["Tippe unten in Safari auf das Teilen-Symbol","Scrolle runter und tippe \"Zum Home-Bildschirm\"","Tippe \"Hinzufügen\" — aekon liegt bei deinen Apps"],
    app_android: ["Tippe auf die drei Punkte (⋮) im Browser","Tippe \"Zum Startbildschirm hinzufügen\" oder \"Installieren\"","Bestätige — aekon liegt auf dem Home-Bildschirm"],
    app_desktop: ["Klick auf das Installieren-Symbol rechts in der Adressleiste","Bestätige \"Installieren\" — aekon öffnet im eigenen Fenster"],
    cta_btn: "auf die passagierliste",
    cta_note: "eine adresse, eine nachricht — wenn drop 01 boardet. nichts dazwischen.",
    form_ph: "deine e-mail-adresse", form_send: "eintragen", form_ok: "du stehst auf der liste — wir melden uns, wenn drop 01 boardet.", form_err: "automatisches senden fehlgeschlagen — nutz bitte die adresse unten.",
    fb_title: "Mail-App hat sich nicht geöffnet?", fb_copy: "adresse kopieren", fb_copied: "kopiert ✓", fb_close: "schließen",
    mail_subject: "Interesse — aekon drop 01 (jacket & shorts)",
    mail_body: "Hi aekon Team,\n\nich interessiere mich für das Drop-01-Set (Zip-Up Jacket + Shorts).\nGröße: \nLand: \n\n"
  },
  fr: {
    hero_eyebrow: "upcoming · vêtements rétro-futuristes",
    hero_dropline: "drop 01 · 2026 · luxembourg",
    scroll: "défiler",
    dep_eyebrow: "arrivées",
    dep_title: "La première collection embarque.",
    dep_sub: "Le Drop 01 arrive. Pas encore de date — certaines choses ne se précipitent pas.",
    board_gate: "porte", board_flight: "vol", board_col: "collection", board_status: "statut",
    leak_stamp: "fuité — interne",
    leak_eyebrow: "premier regard",
    leak_title: "Drop 01 — <span class=\"nowrap\">vu avant d'exister.</span>",
    leak_cap: "drop 01",
    world_title: "Nuits tardives, terminaux vides, un futur qui n'est jamais tout à fait arrivé.",
    world_sub: "– là où vit aekon",
    cap_terminal: "terminal · 03:00",
    cap_car: "tout visible",
    cap_pool: "la piscine où personne ne nage",
    cap_monorail: "transit · quelque part en 1999",
    cap_dash: "route de nuit, lumière verte",
    cap_room: "sunday, 4pm",
    cap_money: "Big money never comes clean",
    cap_horse: "a gift",
    leak_next: "next pieces",
    leak_lose: "lose",
    cap_jet: "i'm out",
    quote: "aekon ne vend pas de sportswear. pas de streetwear non plus. aekon vend un performative lifestyle — des vêtements qui fonctionnent de la porte d'embarquement jusqu'à la côte.",
    quote_attr: "aekon · drop 01",
    footer_contact: "contact", footer_founders: "fondateurs — Finn SCHMIT & Arnel BURKIC",
    app_hint: "aekon, en app", app_title: "ajoutez aekon à l'écran d'accueil", app_intro: "voici comment :",
    app_ios: ["Touchez l'icône de partage en bas de Safari","Faites défiler et touchez \"Sur l'écran d'accueil\"","Touchez \"Ajouter\" — aekon rejoint vos apps"],
    app_android: ["Touchez les trois points (⋮) du navigateur","Touchez \"Ajouter à l'écran d'accueil\" ou \"Installer\"","Confirmez — aekon arrive sur l'écran d'accueil"],
    app_desktop: ["Cliquez sur l'icône d'installation à droite de la barre d'adresse","Confirmez \"Installer\" — aekon s'ouvre dans sa fenêtre"],
    cta_btn: "m'ajouter au manifeste",
    cta_note: "une adresse, un message — au décollage du drop 01. rien entre les deux.",
    form_ph: "votre adresse e-mail", form_send: "embarquer", form_ok: "vous êtes sur la liste — on vous signale le départ du drop 01.", form_err: "envoi automatique impossible — utilisez l'adresse ci-dessous.",
    fb_title: "L'app mail ne s'est pas ouverte ?", fb_copy: "copier l'adresse", fb_copied: "copié ✓", fb_close: "fermer",
    mail_subject: "Intérêt — aekon drop 01 (jacket & shorts)",
    mail_body: "Bonjour l'équipe aekon,\n\nje suis intéressé(e) par le set drop 01 (zip-up jacket + shorts).\nTaille : \nPays : \n\n"
  }
};

function setLang(lang){
  const dict = I18N[lang] || I18N.en;
  document.documentElement.lang = lang;
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const k = el.getAttribute('data-i18n');
    if(dict[k] && typeof dict[k] === 'string') el.innerHTML = dict[k];
  });
  document.querySelectorAll('[data-i18n-ph]').forEach(el => {
    const k = el.getAttribute('data-i18n-ph');
    if(dict[k]) el.placeholder = dict[k];
  });
  document.querySelectorAll('.langs button').forEach(b => {
    b.setAttribute('aria-pressed', b.dataset.lang === lang ? 'true' : 'false');
  });
  const btn = document.getElementById('interestBtn');
  if(btn && dict.mail_subject){
    btn.href = 'mailto:Personell@aekon-clothing.com?subject=' + encodeURIComponent(dict.mail_subject)
             + '&body=' + encodeURIComponent(dict.mail_body);
  }
}
document.querySelectorAll('.langs button').forEach(b => {
  b.addEventListener('click', () => setLang(b.dataset.lang));
});

/* ================= split-flap board ================= */
const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 —·";
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function flapIn(el){
  const target = el.getAttribute('data-flap') || el.textContent;
  if(reduced){ el.textContent = target; return; }
  const len = target.length;
  let frame = 0; const total = 14;
  const iv = setInterval(() => {
    frame++;
    let out = '';
    for(let i=0;i<len;i++){
      const settleAt = Math.floor((i/len)*total*0.6);
      out += (frame >= total - settleAt) ? target[i] : CHARS[Math.floor(Math.random()*CHARS.length)];
    }
    el.textContent = out;
    if(frame >= total){ clearInterval(iv); el.textContent = target; }
  }, 45);
}
let boardPlayed = false;
let flickerTimer = null;
function startFlicker(){
  if(reduced) return;
  const els = Array.from(document.querySelectorAll('[data-flap]'));
  if(!els.length) return;

  // ganze Zeile flackern
  function flickWhole(el){
    const blinks = 1 + Math.floor(Math.random()*3);
    let n = 0;
    (function blink(){
      el.classList.add('flick');
      setTimeout(() => {
        el.classList.remove('flick');
        if(++n < blinks) setTimeout(blink, 60 + Math.random()*90);
      }, 45 + Math.random()*70);
    })();
  }

  // nur einzelne Zeichen flackern (Zeile temporär in Zeichen-Spans zerlegen)
  function flickChars(el){
    const text = el.getAttribute('data-flap') || el.textContent;
    // in Spans zerlegen
    el.textContent = '';
    const spans = [];
    for(const ch of text){
      const s = document.createElement('span');
      s.textContent = ch;
      s.style.display = 'inline-block';
      s.style.whiteSpace = 'pre';
      el.appendChild(s);
      spans.push(s);
    }
    // 1–3 zufällige (Nicht-Leerzeichen-)Zeichen flackern
    const idxs = spans.map((s,i)=>i).filter(i=>spans[i].textContent.trim()!=='');
    const howMany = 1 + Math.floor(Math.random()*3);
    const chosen = new Set();
    while(chosen.size < Math.min(howMany, idxs.length)) chosen.add(idxs[Math.floor(Math.random()*idxs.length)]);
    let pending = chosen.size;
    chosen.forEach(i => {
      const s = spans[i];
      const blinks = 1 + Math.floor(Math.random()*2);
      let n = 0;
      (function blink(){
        s.classList.add('flick');
        setTimeout(() => {
          s.classList.remove('flick');
          if(++n < blinks){ setTimeout(blink, 55 + Math.random()*80); }
          else if(--pending === 0){
            // Zeile wiederherstellen (Spans zurück zu Text)
            setTimeout(()=>{ el.textContent = text; }, 120);
          }
        }, 45 + Math.random()*70);
      })();
    });
    if(pending===0) el.textContent = text;
  }

  function tick(){
    // ~55% einzelne Zeichen, ~45% ganze Zeile(n) — überraschend, nicht durchschaubar
    if(Math.random() < 0.55){
      const el = els[Math.floor(Math.random()*els.length)];
      flickChars(el);
    } else {
      const count = 1 + Math.floor(Math.random()*2);
      const picks = new Set();
      while(picks.size < count) picks.add(els[Math.floor(Math.random()*els.length)]);
      picks.forEach(flickWhole);
    }
    flickerTimer = setTimeout(tick, 1300 + Math.random()*3400);
  }
  flickerTimer = setTimeout(tick, 1800 + Math.random()*2200);
}
new IntersectionObserver((es) => {
  es.forEach(e => {
    if(e.isIntersecting && !boardPlayed){
      boardPlayed = true;
      document.querySelectorAll('[data-flap]').forEach((el,i) => setTimeout(() => flapIn(el), i*110));
      setTimeout(startFlicker, els_total_delay());
    }
    // Flacker nur laufen lassen, wenn Board sichtbar ist (spart Ressourcen)
    if(!e.isIntersecting && flickerTimer){ clearTimeout(flickerTimer); flickerTimer = null; }
    else if(e.isIntersecting && boardPlayed && !flickerTimer){ startFlicker(); }
  });
}, {threshold:0.3}).observe(document.querySelector('.board-section'));
function els_total_delay(){
  return document.querySelectorAll('[data-flap]').length * 110 + 900;
}

/* ================= reveal on scroll ================= */
// Progressive enhancement: content is visible by default (works even if JS never runs,
// e.g. in file previews / Quick Look / PDF export). JS only adds the subtle entrance animation.
if(!reduced){
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('pre'));
  const revObs = new IntersectionObserver((es) => {
    es.forEach(e => { if(e.isIntersecting){ e.target.classList.add('vis'); e.target.classList.remove('pre'); revObs.unobserve(e.target); } });
  }, {threshold:0.12});
  document.querySelectorAll('.reveal').forEach(el => revObs.observe(el));
}

/* ================= 3D tilt card ================= */
const card = document.getElementById('tiltCard');
const scene = card.closest('.tilt-scene');
if(!reduced && matchMedia('(pointer:fine)').matches){
  scene.addEventListener('mousemove', (e) => {
    const r = scene.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    card.style.transform = `rotate(-1.6deg) rotateY(${x*10}deg) rotateX(${ -y*8 }deg) translateZ(6px)`;
  });
  scene.addEventListener('mouseleave', () => {
    card.style.transform = 'rotate(-1.6deg)';
  });
}

/* ================= interest form (FormSubmit) + fallback ================= */
(function(){
  const btn = document.getElementById('interestBtn');
  const fb = document.getElementById('mailFb');
  const copyBtn = document.getElementById('fbCopy');
  const closeBtn = document.getElementById('fbClose');
  const form = document.getElementById('intForm');
  const emailIn = document.getElementById('intEmail');
  const send = document.getElementById('intSend');
  const okLine = document.getElementById('intSuccess');
  const errLine = document.getElementById('intErr');
  if(!btn || !fb) return;

  // Klick auf CTA: Formular einblenden statt Mail-App (JS aktiv). Ohne JS bleibt der mailto-Link.
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    btn.style.display = 'none';
    form.hidden = false;
    emailIn.focus();
  });

  // Shopify lehnt AJAX-Posts auf /contact ab -> normaler Formular-Post (Seite laedt neu).
  form.addEventListener('submit', (e) => {
    const email = (emailIn.value || '').trim();
    if(!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
      e.preventDefault(); emailIn.focus(); return;
    }
    // Honeypot gefuellt -> Bot: still abbrechen, Erfolg vortaeuschen
    const honey = form.querySelector('[name="_honey"]');
    if(honey && honey.value){
      e.preventDefault(); form.hidden = true; okLine.hidden = false; return;
    }
    // Im Theme-Editor darf die Seite nicht navigieren, sonst bricht der Editor ab
    if(window.Shopify && window.Shopify.designMode){
      e.preventDefault();
      form.hidden = true; okLine.hidden = false;
      return;
    }
    errLine.hidden = true;
    send.disabled = true;
    // kein preventDefault -> Browser postet das Formular normal an Shopify
  });

  // Nach dem Reload: Erfolgszustand sauber darstellen
  if(okLine && !okLine.hidden){
    btn.style.display = 'none';
    form.hidden = true;
    requestAnimationFrame(() => {
      okLine.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  closeBtn.addEventListener('click', () => { fb.hidden = true; });
  copyBtn.addEventListener('click', async () => {
    const addr = 'Personell@aekon-clothing.com';
    let ok = false;
    try{ await navigator.clipboard.writeText(addr); ok = true; }
    catch(e){
      try{
        const ta = document.createElement('textarea');
        ta.value = addr; document.body.appendChild(ta); ta.select();
        ok = document.execCommand('copy'); document.body.removeChild(ta);
      }catch(e2){}
    }
    if(ok){
      const lang = document.documentElement.lang || 'en';
      copyBtn.textContent = (I18N[lang] && I18N[lang].fb_copied) || 'copied ✓';
      setTimeout(() => {
        const l = document.documentElement.lang || 'en';
        copyBtn.textContent = (I18N[l] && I18N[l].fb_copy) || 'copy address';
      }, 2200);
    }
  });
})();

/* ================= plane + banner (sky) — 3 feste dokument-routen ================= */
(function(){
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reducedMotion) return;
  const rig = document.getElementById('planeRig');
  const shape = document.getElementById('planeShape');
  const bannerDark = rig.querySelector('.banner-dark');
  const bannerLight = rig.querySelector('.banner-light');
  const rope = rig.querySelector('.rope');
  if(!rig) return;

  // Kondensstreifen-Canvas aus
  const canvas = document.getElementById('trailCanvas');
  if(canvas) canvas.style.display = 'none';

  // sky-Container muss dokument-verankert sein (absolut, scrollt mit der Seite)
  const sky = document.getElementById('sky');
  if(sky){ sky.style.position='absolute'; sky.style.top='0'; sky.style.left='0'; sky.style.width='100%'; sky.style.height=document.body.offsetHeight+'px'; sky.style.overflow='hidden'; }

  const darkEls = () => Array.from(document.querySelectorAll('.hero, .board-section, .chromewrap, .statement, footer'));
  function isDarkAtDoc(docY){
    // WICHTIG: dokument-absolute Position via Rect + scrollY berechnen.
    // offsetTop waere relativ zum offsetParent (z.B. .chromewrap) und damit falsch,
    // wodurch das Flugzeug ueber dunklem Grund dunkel (= unsichtbar) bliebe.
    const sy = window.scrollY;
    for(const el of darkEls()){
      const r = el.getBoundingClientRect();
      const top = r.top + sy, bottom = r.bottom + sy;
      if(docY >= top && docY <= bottom) return true;
    }
    return false;
  }

  // Die festen Routen als DOKUMENT-Y-Positionen. Jede Route wird gegen Fotos geprüft und
  // bei Kollision verschoben — so fliegt das Flugzeug auf KEINEM Bildschirm hinter Fotos.
  function computeRoutes(){
    function docTop(el){ const r=el.getBoundingClientRect(); return r.top+window.scrollY; }
    function docBot(el){ const r=el.getBoundingClientRect(); return r.bottom+window.scrollY; }
    const board = document.querySelector('.board-section');
    const stmt  = document.querySelector('.statement');

    // Alle Foto-Zonen sammeln (Leak-Karten + Galerie), die das Flugzeug meiden muss
    const photoZones = [];
    document.querySelectorAll('.leak-card, .line-gallery, .peg-item').forEach(el=>{
      photoZones.push({ top: docTop(el)-30, bottom: docBot(el)+30 });
    });
    function hitsPhoto(y){
      return photoZones.some(z => y >= z.top && y <= z.bottom);
    }

    const routes = [];
    // Route 1: Lücke unter dem Board-Kasten
    if(board){
      const box = board.querySelector('.board');
      let y;
      if(box){
        const boxBot = docBot(box);
        const boardBot = docTop(board) + board.getBoundingClientRect().height;
        y = (boxBot + boardBot)/2;
      } else {
        y = docTop(board) + 200;
      }
      // falls die Route ein Foto trifft: in die obere Board-Lücke ausweichen
      if(hitsPhoto(y)){ y = docTop(board) + 120; }
      routes.push({ y, dir: 1 });
    }
    // Route 2: untere Lücke der Statement-Sektion
    if(stmt){
      const bq = stmt.querySelector('blockquote');
      let y;
      if(bq){
        const bqBot = docBot(bq);
        const stmtBot = docTop(stmt) + stmt.getBoundingClientRect().height;
        y = (bqBot + stmtBot)/2;
      } else {
        y = docTop(stmt) + stmt.getBoundingClientRect().height*0.78;
      }
      if(hitsPhoto(y)){ y = docTop(stmt) + 100; }
      routes.push({ y, dir: -1 });
    }
    // Sicherheits-Filter: nur Routen behalten, die WIRKLICH kein Foto treffen
    const safe = routes.filter(r => !hitsPhoto(r.y));
    return safe.length ? safe : (routes.length ? routes : [{y: innerHeight*1.4, dir:1}]);
  }
  let routes = computeRoutes();
  window.addEventListener('resize', () => {
    routes = computeRoutes();
    if(sky) sky.style.height = document.body.offsetHeight+'px';
  });

  let routeIdx = -1;
  let flight=null;
  function newFlight(){
    // nächste Route (immer der Reihe nach -> nie zweimal hintereinander dieselbe Stelle)
    routeIdx = (routeIdx + 1) % routes.length;
    const route = routes[routeIdx];
    const dir = route.dir;
    const docY0 = route.y;                            // FESTE Dokument-Höhe dieser Route
    const speed = 0.026 + Math.random()*0.010;        // px pro ms — ruhig, leicht variabel
    const startX = dir===1 ? -190 : innerWidth+190;
    flight = { dir, docY0, x:startX, t:0, speed };

    if(dir===1){
      shape.setAttribute('transform','');
      rig.classList.remove('flip');
    } else {
      shape.setAttribute('transform','scale(-1,1) translate(-160,0)');
      rig.classList.add('flip');
    }
  }
  newFlight();

  let last=performance.now();
  function frame(now){
    const dt = Math.min(48, now-last); last=now;

    if(flight){
      flight.t += dt;
      flight.x += flight.dir * flight.speed * dt;

      // Position: X = Bildschirm-X (fliegt horizontal durch), Y = FESTE Dokument-Höhe der Route.
      // Da der sky-Container dokument-verankert (absolute) ist, wandert das Flugzeug beim Scrollen
      // natürlich mit der Seite mit — man sieht es nur, wenn die Route im Blick ist.
      const docY = flight.docY0;
      rig.style.transform = `translate(${flight.x}px, ${docY}px)`;

      // Farbe nach Untergrund (Dokument-Position)
      rig.classList.toggle('on-dark', isDarkAtDoc(docY));

      // dezentes Flattern
      const flutter = Math.sin(flight.t/150)*2.2 + Math.sin(flight.t/58)*1.1;
      rope.style.transform = `rotate(${flutter*0.4}deg)`;
      bannerDark.style.transform = `rotate(${flutter*0.45}deg) skewX(${flutter*0.5}deg)`;
      bannerLight.style.transform = `rotate(${flutter*0.45}deg) skewX(${flutter*0.5}deg)`;

      const done = (flight.dir===1 && flight.x > innerWidth+210) ||
                   (flight.dir===-1 && flight.x < -210);
      if(done){
        flight=null;
        rig.style.transform = 'translate(-9999px,-9999px)';
        setTimeout(newFlight, 3500 + Math.random()*5500);
      }
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* ================= gallery line — infinite drag/swipe + auto-drift ================= */
(function(){
  const gal = document.getElementById('lineGallery');
  const track = document.getElementById('lineTrack');
  if(!gal || !track) return;

  // Für nahtlose Endlosschleife: Originalset klonen und anhängen (2x), damit beim Umschlagen
  // immer Fotos gerendert sind. seqWidth = Breite EINES Originalsets.
  const originals = Array.from(track.children);
  function cloneSet(){
    originals.forEach(node => track.appendChild(node.cloneNode(true)));
  }
  cloneSet(); cloneSet();   // insgesamt 3 Sets

  let seqWidth = 0;
  function measure(){
    // Breite eines Originalsets = Summe der ersten N Items inkl. gap
    const style = getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
    let w = 0;
    originals.forEach(node => { w += node.getBoundingClientRect().width + gap; });
    seqWidth = w;
  }
  measure();
  window.addEventListener('resize', measure);

  // pos läuft frei; gerendert wird pos modulo seqWidth (immer im mittleren Set gehalten)
  let pos = -seqWidth;          // im mittleren Set starten
  let dragging=false, startX=0, startPos=0, moved=0, vel=0, lastX=0, lastT=0, raf=null;

  function wrap(){
    if(seqWidth<=0) return;
    // pos immer im Bereich [-2*seqWidth, 0] halten -> optisch identisch, nie am Rand
    while(pos <= -2*seqWidth) pos += seqWidth;
    while(pos > -seqWidth)    pos -= seqWidth;
  }
  function apply(){ track.style.transform = 'translateX(' + pos + 'px)'; }

  function down(x){
    dragging=true; startX=x; startPos=pos; moved=0; vel=0; lastX=x; lastT=performance.now();
    gal.classList.add('dragging'); if(raf){ cancelAnimationFrame(raf); raf=null; }
    autoOn=false;
  }
  function move(x){
    if(!dragging) return;
    const dx=x-startX; moved=Math.abs(dx);
    pos = startPos + dx; wrap(); apply();
    const now=performance.now(), dt=now-lastT;
    if(dt>0){ vel=(x-lastX)/dt; lastX=x; lastT=now; }
  }
  function up(){
    if(!dragging) return;
    dragging=false; gal.classList.remove('dragging');
    scheduleResume();
    function inertia(){
      if(Math.abs(vel)<0.015){ raf=null; scheduleResume(); return; }
      pos += vel*16; vel*=0.94; wrap(); apply();
      raf=requestAnimationFrame(inertia);
    }
    raf=requestAnimationFrame(inertia);
  }

  gal.addEventListener('mousedown', e => { e.preventDefault(); down(e.clientX); });
  window.addEventListener('mousemove', e => move(e.clientX));
  window.addEventListener('mouseup', up);
  gal.addEventListener('touchstart', e => down(e.touches[0].clientX), {passive:true});
  gal.addEventListener('touchmove', e => move(e.touches[0].clientX), {passive:true});
  gal.addEventListener('touchend', up);
  track.addEventListener('click', e => { if(moved>6){ e.preventDefault(); e.stopPropagation(); } }, true);
  gal.addEventListener('wheel', e => {
    if(Math.abs(e.deltaX) > Math.abs(e.deltaY)){ e.preventDefault(); autoOn=false; pos -= e.deltaX; wrap(); apply(); scheduleResume(); }
  }, {passive:false});

  // sanftes automatisches Driften als Hinweis (läuft endlos, stoppt bei Interaktion)
  let autoOn=true;
  function autoStep(){
    if(!autoOn || dragging){ raf=null; return; }
    pos -= 0.35; wrap(); apply();
    raf=requestAnimationFrame(autoStep);
  }

  // nach 1s ohne Interaktion wieder automatisch anlaufen
  let idleTimer=null;
  function scheduleResume(){
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function tick(){
      if(dragging) return;                                    // noch gehalten -> beim Loslassen erneut
      if(raf){ idleTimer=setTimeout(tick, 120); return; }      // Nachlauf noch aktiv -> kurz warten
      autoOn = true;
      raf = requestAnimationFrame(autoStep);
    }, 1000);
  }

  ['mousedown','touchstart','wheel'].forEach(ev => gal.addEventListener(ev, ()=>{ autoOn=false; scheduleResume(); }, {passive:true}));

  new IntersectionObserver((es)=>{
    es.forEach(e=>{
      if(e.isIntersecting){ measure(); wrap(); apply(); if(autoOn && !raf) raf=requestAnimationFrame(autoStep); }
      else if(raf){ cancelAnimationFrame(raf); raf=null; }
    });
  }, {threshold:0.15}).observe(gal);

  // initial positionieren
  requestAnimationFrame(()=>{ measure(); pos=-seqWidth; apply(); });
})();

/* ================= app hint (PWA) ================= */
(function(){
  const chip = document.getElementById('appChip');
  const pop = document.getElementById('appPop');
  const stepsEl = document.getElementById('apSteps');
  const introEl = pop ? pop.querySelector('.ap-intro') : null;
  const titleEl = pop ? pop.querySelector('.ap-title') : null;
  const close = document.getElementById('apClose');
  const hint = document.getElementById('appHint');
  if(!chip) return;
  if(window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true){
    hint.style.display = 'none'; return;
  }
  function platformKey(){
    const ua = navigator.userAgent;
    if(/iPhone|iPad|iPod/.test(ua)) return 'app_ios';
    if(/Android/.test(ua)) return 'app_android';
    if(matchMedia('(pointer:fine)').matches) return 'app_desktop';
    return 'app_ios';
  }
  function fillSteps(){
    const lang = document.documentElement.lang || 'en';
    const dict = I18N[lang] || I18N.en;
    if(titleEl && dict.app_title) titleEl.textContent = dict.app_title;
    if(introEl && dict.app_intro) introEl.textContent = dict.app_intro;
    const steps = dict[platformKey()] || dict.app_ios;
    stepsEl.innerHTML = '';
    (steps||[]).forEach(s => {
      const li = document.createElement('li');
      li.textContent = s;
      stepsEl.appendChild(li);
    });
  }
  chip.addEventListener('click', () => {
    const opening = pop.hidden;
    pop.hidden = !opening;
    if(opening){ fillSteps(); }
    chip.setAttribute('aria-expanded', opening ? 'true' : 'false');
  });
  close.addEventListener('click', () => { pop.hidden = true; chip.setAttribute('aria-expanded','false'); });
})();


/* ================= nav contrast on dark sections ================= */
const nav = document.querySelector('.nav');
const darkSections = document.querySelectorAll('.hero, .board-section, .chromewrap, .statement, footer');
const navObs = new IntersectionObserver((es) => {
  let onDark = false;
  darkSections.forEach(s => {
    const r = s.getBoundingClientRect();
    if(r.top < 60 && r.bottom > 60) onDark = true;
  });
  nav.classList.toggle('on-dark', onDark);
}, {threshold:[0,0.1,0.5,1]});
darkSections.forEach(s => navObs.observe(s));
window.addEventListener('scroll', () => {
  let onDark = false;
  darkSections.forEach(s => {
    const r = s.getBoundingClientRect();
    if(r.top < 60 && r.bottom > 60) onDark = true;
  });
  nav.classList.toggle('on-dark', onDark);
}, {passive:true});

/* ================= torch / flashlight reveal (hero + board section) ================= */
(function(){
  if(window.matchMedia('(hover:none)').matches) return;
  const hosts = document.querySelectorAll('.torch-host');
  if(!hosts.length) return;

  hosts.forEach(sec => {
    let x = 0, y = 0, raf = null, on = false;

    function paint(){
      raf = null;
      sec.style.setProperty('--mx', x + 'px');
      sec.style.setProperty('--my', y + 'px');
    }

    sec.addEventListener('pointermove', (e) => {
      if(e.pointerType === 'touch') return;
      const r = sec.getBoundingClientRect();
      x = e.clientX - r.left;
      y = e.clientY - r.top;
      if(!on){ on = true; sec.classList.add('torch-on'); }
      if(!raf) raf = requestAnimationFrame(paint);
    }, {passive:true});

    sec.addEventListener('pointerleave', () => {
      on = false;
      sec.classList.remove('torch-on');
    }, {passive:true});
  });
})();